/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import AddressComponent from 'src/components/AddressComponent';
import RemarkComponent from 'src/containers/remarks-container/RemarkContainer';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import React, { useCallback } from 'react';
import { Formik, Form } from 'formik';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import RoutingUtil from 'src/utils/RoutingUtil';
import { isProduction } from 'src/config/index';
import { withFormikDevtools } from 'formik-devtools-extension';
import FormikToggle from 'src/components/formik/FormikToggle';
import FormikInput from 'src/components/formik/FormikInput';
import FormikSelect from 'src/components/formik/FormikSelect';
import FormikCreateSearchClear from 'src/components/formik/FormikCreateSearchClear';
import { usePrevious } from 'src/utils/ReactHooksUtil';
import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { includeStamp } from 'src/utils/StampUtils';
import PictureContainer from '../files-container/PictureContainer';
import FileContainer from '../files-container/FileContainer';
import {
    companyResetAction,
    companyUpsertAction,
} from './actions/CompanyActions';
import { CompanyYupSchema } from './CompanyPropTypes';
import { COMPANY_TYPES_LIST, PAYOUT } from './CompanyConstants';
import FormikRadio from 'src/components/formik/FormikRadio';
import PermissionHOC from 'src/hoc/PermissionHOC';


const Render = (props) => {
    // DEV TOOL
    if (!isProduction()) {
        withFormikDevtools(props);
    }

    const {
        values,
        // errors,
        // touched,
        isSubmitting,
        onSearch,
        onClear,
        resetForm,
    } = props;

    return (
        <>
            <div>
                <div className="card mt-3">
                    <div className="card-body">
                        <h5 className="card-title">Company Details</h5>
                        <Form autoComplete="disabled">
                            <div className="form-row">
                                <div className="form-group col">
                                    <PictureContainer
                                        refId={values._id}
                                        source="companies-logo"
                                        className="img-thumbnail profile-picture"
                                    />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group col">
                                    <FormikToggle name="active" />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group  col-md-3">
                                    <label>Company Name</label>
                                    <FormikInput
                                        name="companyName"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                                <div className="form-group  col-md-3">
                                    <label>Company Display Name</label>

                                    <FormikInput
                                        name="companyDisplayName"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                            </div>

                            <AddressComponent
                                values={values.address}
                                name="address"
                            />

                            <div className="form-row">
                                <div className="form-group col-md-6">
                                    <label>Company Type</label>
                                    <FormikSelect
                                        name="companyType"
                                        items={COMPANY_TYPES_LIST}
                                        className="form-control"
                                    />
                                </div>

                                <div className="form-group col-md-6">
                                    <label>CIN No.</label>

                                    <FormikInput
                                        name="cin"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                                <div className="form-group col-md-6">
                                    <label>LLPN</label>

                                    <FormikInput
                                        name="llpn"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                                <div className="form-group col-md-6">
                                    <label>PAN No.</label>

                                    <FormikInput
                                        name="pan"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                                <div className="form-group col-md-6">
                                    <label>GSTIN</label>

                                    <FormikInput
                                        name="gstin"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                            </div>

                            <div className="card mt-3">
                                <div className="card-body">
                                    <h5 className="card-title">Bank Details</h5>

                                    <div className="form-row">
                                        <div className="form-group col-md-4">
                                            <label>Pan Card</label>

                                            <FormikInput
                                                name="bankInfo.pancard"
                                                type="text"
                                                className="form-control"
                                            />
                                        </div>

                                        <div className="form-group col-md-4">
                                            <label>Account Number</label>

                                            <FormikInput
                                                name="bankInfo.accountNumber"
                                                type="text"
                                                className="form-control"
                                            />
                                        </div>

                                        <div className="form-group col-md-4">
                                            <label>IFSC Code</label>

                                            <FormikInput
                                                name="bankInfo.ifisc"
                                                type="text"
                                                className="form-control"
                                            />
                                        </div>

                                        <div className="form-group col-md-4">
                                            <label>Bank Name</label>

                                            <FormikInput
                                                name="bankInfo.bankName"
                                                type="text"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <PermissionHOC scope='master.company_manager.calculation.view' >
                                <div className="card mt-3">
                                    <div className="card-body">
                                        <h5 className="card-title">Payout calculation</h5>

                                        <div className="form-row">
                                            <div className="form-group col-md-3">
                                                <FormikRadio
                                                    name="payOut"
                                                    value={PAYOUT.LOANAMT_CROSSSALE_LESS_PF}
                                                    isChecked={(values.payOut == "LoanAmtCrossSaleLessPF") ? true : false}

                                                />
                                                {" "}
                                                <label>Loan Amount + Cross Sell - P.F.
                                                    {/* Total Loan Amount (Gross) */}
                                                </label>
                                            </div>

                                            <div className="form-group col-md-3">
                                                <FormikRadio
                                                    name="payOut"
                                                    value={PAYOUT.LOANAMT_CROSSSALE}
                                                    isChecked={(values.payOut == "LoanAmtCrossSale") ? true : false}

                                                />
                                                {" "}
                                                <label>Loan Amount + Cross Sell
                                                    {/* Total Loan Amount - Cross Sell */}
                                                </label>
                                            </div>

                                            <div className="form-group col-md-3">
                                                <FormikRadio
                                                    name="payOut"
                                                    value={PAYOUT.LOANAMT_LESS_PF}
                                                    isChecked={(values.payOut == "LoanAmtLessPF") ? true : false}
                                                    
                                                />
                                                {" "}
                                                <label>Loan Amount - PF
                                                    {/* Net Disbursal (Total/Gross Loan Amount - Cross Sell - PF) */}
                                                </label>
                                            </div>
                                            <div className="form-group col-md-3">
                                                <FormikRadio
                                                    name="payOut"
                                                    value={PAYOUT.LOANAMT}
                                                    isChecked={(values.payOut == "LoanAmt") ? true : false}

                                                />
                                                {" "}
                                                <label>Loan Amount
                                                    {/* Net Disbursal (Total/Gross Loan Amount - Cross Sell - PF) */}
                                                </label>
                                            </div>
                                        </div>
                                        <hr />
                                        <h5 className="card-title">PDD Amount</h5>
                                        <div className="form-row">
                                        <div className="form-group col-md-4">
                                            <label>PDD Amount</label>
                                            <FormikInput
                                                name="PDDAmount"
                                                type="number"
                                                 placeholder="0"
                                                value={values.PDDAmount}
                                                className="form-control"
                                            />
                                            </div>
                                            <div className="form-group col-md-4">
                                            <label>PDD Amount for New Car</label>
                                            <FormikInput
                                                name="newPDDAmount"
                                                type="number"
                                                placeholder="0"
                                                value={values.newPDDAmount}
                                                className="form-control"
                                            />
                                            </div>
                                            <div className="form-group col-md-4">
                                            <label>PDD Amount for Used car</label>
                                            <FormikInput
                                                name="usedPDDAmount"
                                                type="number"
                                                 placeholder="0"
                                                value={values.usedPDDAmount}
                                                className="form-control"
                                            />
                                            </div>
                                            </div>
                                            <hr />
                                            <h5 className="card-title">GST calculation</h5>
                                            {/* <div className="form-row">
                                        <div className="form-group col-md-3">
                                        <FormikRadio
                                                    name="GSTCalc"
                                                    value="isExclusive"
                                                    isChecked={(values.GSTCalc == "isExclusive") ? true : false}
                                                />
                                                {" "}
                                            <label>Exclusive GST (i.e. + 18%)
                                            </label>
                                        </div>

                                        <div className="form-group col-md-3">
                                        <FormikRadio
                                                    name="GSTCalc"
                                                    value="isInclusive"
                                                    isChecked={(values.GSTCalc == "isInclusive") ? true : false}
                                                />
                                                 {" "}
                                            <label>Inclusive GST (i.e. - 18%) 
                                            </label>
                                        </div>

                                        <div className="form-group col-md-3">
                                        <FormikRadio
                                                    name="GSTCalc"
                                                    value="isExclusiveHalf"
                                                    isChecked={(values.GSTCalc == "isExclusiveHalf") ? true : false}
                                                />
                                                 {" "}
                                            <label>Exclusive Half GST (i.e. + 9%)
                                               
                                               
                                            </label>
                                        </div>
                                        <div className="form-group col-md-3">
                                        <FormikRadio
                                                    name="GSTCalc"
                                                    value="isExclusive18/118"
                                                    isChecked={(values.GSTCalc == "isExclusive18/118") ? true : false}
                                                />
                                                {" "}
                                            <label>Exclusive GST (i.e. + 18/118)
                                            </label>
                                        </div>

                                    </div> */}
                                            <h6 className="card-title">For New Car</h6>
                                            <div className="form-row">
                                                <div className="form-group col-md-3">
                                                    <FormikRadio
                                                        name="newGSTCalc"
                                                        value="newIsExclusive"
                                                        isChecked={(values.newGSTCalc == "newIsExclusive") ? true : false}
                                                    />
                                                    {" "}
                                                    <label>Exclusive GST (i.e. + 18%)
                                                    </label>
                                                </div>

                                                <div className="form-group col-md-3">
                                                    <FormikRadio
                                                        name="newGSTCalc"
                                                        value="newIsInclusive"
                                                        isChecked={(values.newGSTCalc == "newIsInclusive") ? true : false}
                                                    />
                                                    {" "}
                                                    <label>Inclusive GST (i.e. - 18%)
                                                    </label>
                                                </div>

                                                <div className="form-group col-md-3">
                                                    <FormikRadio
                                                        name="newGSTCalc"
                                                        value="newIsExclusiveHalf"
                                                        isChecked={(values.newGSTCalc == "newIsExclusiveHalf") ? true : false}
                                                    />
                                                    {" "}
                                                    <label>Exclusive Half GST (i.e. + 9%)


                                                    </label>
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <FormikRadio
                                                        name="newGSTCalc"
                                                        value="newIsExclusive18/118"
                                                        isChecked={(values.newGSTCalc == "newIsExclusive18/118") ? true : false}
                                                    />
                                                    {" "}
                                                    <label>Exclusive GST (i.e. + 18/118)
                                                    </label>
                                                </div>

                                            </div>
                                            <h6 className="card-title">For Used Car</h6>
                                            <div className="form-row">
                                                <div className="form-group col-md-3">
                                                    <FormikRadio
                                                        name="usedGSTCalc"
                                                        value="usedIsExclusive"
                                                        isChecked={(values.usedGSTCalc == "usedIsExclusive") ? true : false}
                                                    />
                                                    {" "}
                                                    <label>Exclusive GST (i.e. + 18%)
                                                    </label>
                                                </div>

                                                <div className="form-group col-md-3">
                                                    <FormikRadio
                                                        name="usedGSTCalc"
                                                        value="usedIsInclusive"
                                                        isChecked={(values.usedGSTCalc == "usedIsInclusive") ? true : false}
                                                    />
                                                    {" "}
                                                    <label>Inclusive GST (i.e. - 18%)
                                                    </label>
                                                </div>

                                                <div className="form-group col-md-3">
                                                    <FormikRadio
                                                        name="usedGSTCalc"
                                                        value="usedIsExclusiveHalf"
                                                        isChecked={(values.usedGSTCalc == "usedIsExclusiveHalf") ? true : false}
                                                    />
                                                    {" "}
                                                    <label>Exclusive Half GST (i.e. + 9%)


                                                    </label>
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <FormikRadio
                                                        name="usedGSTCalc"
                                                        value="usedIsExclusive18/118"
                                                        isChecked={(values.usedGSTCalc == "usedIsExclusive18/118") ? true : false}
                                                    />
                                                    {" "}
                                                    <label>Exclusive GST (i.e. + 18/118)
                                                    </label>
                                                </div>

                                            </div>

                                        </div>
                                    </div>

                            </PermissionHOC>
                            <div className="text-center py-4 mt-3">
                                <FormikCreateSearchClear
                                    isSubmitting={isSubmitting}
                                    isUpdate={Boolean(values._id)}
                                    onSearch={onSearch}
                                    onClear={onClear}
                                    resetForm={resetForm}
                                    values={values}
                                    submitScope="master.company_manager.manage.submit"
                                    searchScope="master.company_manager.manage.search"
                                />
                            </div>
                        </Form>
                    </div>
                </div>
                <div className="border-top my-3" />
                <div className="form-group">
                    <RemarkComponent
                        refId={values._id}
                        source="companies"
                        title="Company Remarks"
                    />
                </div>
                <FileContainer
                    refId={values._id}
                    source="companies"
                    title="Company Files"
                    className="mt-3"
                />
            </div>
        </>
    );
};

Render.propTypes = {
    isSubmitting: PropTypes.bool.isRequired,
    onSearch: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    values: PropTypes.shape({
        _id: PropTypes.string,
        address: PropTypes.any,
        authorizedPersonId: PropTypes.string,
    }).isRequired,
};

// setting submit button state after submitting
let setSubmitting = () => { };

const CompanyFrom = () => {
    const history = useHistory();
    // REDUX
    const dispatch = useDispatch();
    const { currentRecord, upsertReqStatus } = useSelector(
        (state) => state.CompanyReducer,
        shallowEqual,
    );

    // if current record changed or request status changed the enable submit
    usePrevious(
        {
            currentRecord,
            upsertReqStatus,
        },
        (prev) => {
            if (
                prev.currentRecord !== currentRecord
                || (upsertReqStatus
                    && prev.upsertReqStatus !== upsertReqStatus
                    && upsertReqStatus !== REQUEST_STATUS.PENDING)
            ) {
                setSubmitting(false);
            }
        },
    );

    const onSubmit = useCallback(
        (values, formikUtils) => {
            ({ setSubmitting } = formikUtils);
            includeStamp(values);
            dispatch(companyUpsertAction(values));
        },
        [
            dispatch,
        ],
    );

    const onSearch = useCallback(
        ({
            stateId,
            companyName,
            pincode,
            companyType,
            flatNo,
            buildingNo,
            area,
        }) => {
            history.push(
                RoutingUtil.companySearch({
                    stateId,
                    companyName,
                    pincode,
                    companyType,
                    flatNo,
                    buildingNo,
                    area,
                }),
            );
        },
        [
            history,
        ],
    );

    const onClear = useCallback(() => {
        dispatch(companyResetAction());
    }, [
        dispatch,
    ]);

    return (
        <Formik
            onSubmit={onSubmit}
            onClear={onClear}
            initialValues={currentRecord}
            validationSchema={CompanyYupSchema}
            onSearch={onSearch}
            enableReinitialize
        >
            {(formikProps) => (
                <Render
                    onClear={onClear}
                    onSearch={onSearch}
                    {...formikProps}
                />
            )}
        </Formik>
    );
};

export default CompanyFrom;
